import { Arc } from './OcdCycleArc';
import { Variants } from 'framer-motion';

interface OcdCycleCircleProps {
    arcVariants: Record<string, Variants>;
    currentStep: string;
}

export const OcdCycleCircle = ({ arcVariants, currentStep }: OcdCycleCircleProps) => {
    const radius = 196;
    const center = 216;

    return (
        <svg className="w-full h-full" viewBox="0 0 432 432" fill="none">
            <Arc
                startX={center}
                startY={center - radius}
                endX={center + radius}
                endY={center}
                radius={radius}
                variants={arcVariants.north}
                currentStep={currentStep}
            />
            <Arc
                startX={center + radius}
                startY={center}
                endX={center + radius * Math.cos(Math.PI / 4)}
                endY={center + radius * Math.sin(Math.PI / 4)}
                radius={radius}
                variants={arcVariants.eastTop}
                currentStep={currentStep}
            />
            <Arc
                startX={center + radius * Math.cos(Math.PI / 4)}
                startY={center + radius * Math.sin(Math.PI / 4)}
                endX={center}
                endY={center + radius}
                radius={radius}
                variants={arcVariants.eastBottom}
                currentStep={currentStep}
            />
            <Arc
                startX={center}
                startY={center + radius}
                endX={center - radius}
                endY={center}
                radius={radius}
                variants={arcVariants.south}
                currentStep={currentStep}
            />
            <Arc
                startX={center - radius}
                startY={center}
                endX={center}
                endY={center - radius}
                radius={radius}
                variants={arcVariants.west}
                currentStep={currentStep}
            />
        </svg>
    );
};